import React, { useContext, useEffect, useRef, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import OpenPopupBtn from "../../../common/OpenPopupBtn";
import { Cases, DELETE_CONFIRM, modalsName } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import StepsPopup from "./StepsPopup";
import EditIcon from "@mui/icons-material/Edit";
import StepsParentPopup from "./StepsParentPopup";
import { FILE_UPLOAD_API } from "../apis/SliderApi/SliderApi";
import {
  isCheckValue,
  isEmptyObject,
  randomStr,
  rgbColorCreate,
} from "../../../../utils/helper";
import { FILE_TYPE, ThemeNo, titleUpdateKey } from "../../../../constant";
import { IconButton } from "@material-ui/core";
import { Settings, Trash } from "react-feather";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import SimpleReactValidator from "simple-react-validator";
import StepsContext from "../../../context/StepsContext/StepsContext";
import {
  deleteSteps,
  getSteps,
  getStepsDetails,
  postSteps,
  putUpdateSteps,
  updateStatus,
} from "../apis/StepsApi/StepsApi";
import SettingStepsParentPopup from "./SettingStepsParentPopup";
import DeleteSection from "../../../common/DeleteSection";
import SettingMultiWebContext from "../../../../context/SettingMultiWebContext/SettingMultiWebContext";
import {
  StepsStyleOneReset,
  StepsStyleOneSubFun,
  StepsStyleTwoSubFun,
  StepsThemeOneFunction,
  StepsThemeTwoFunction,
} from "./StepsStyleFunction";
import { uploadFileToSpaces } from "../../../apis/dashboardAPi/DeshboardApi";

const Steps = (props) => {
  const {
    pageConfigDetails,
    webMasterDetail,
    getData,
    stepsDetail,
    contentMapId,
    ByteMiniWeb_Dashboard,
    contentDetail,
  } = props;
  const { allPopupState, setAllPopupState } = useContext(
    ByteCardBuilderContext
  );
  const { setCloneAlignModal, setAlignFormData, setCloneFormData } = useContext(
    SettingMultiWebContext
  );
  const parentValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const childValidator = useRef(new SimpleReactValidator());
  const {
    fromData,
    setFormData,
    formDataChild,
    setFormDataChild,
    id,
    setId,
    setIsEdit,
    isEdit,
    setFilter,
    apiDataOurTeam: apiDataImageParent,
    setApiDataOurTeam: setApiDataImageParent,
    setSkill,
    setGalleryImgId,
    setSettingFormData,
    settingFormData,
    isParent,
    setIsParent,
    childId,
    setChildId,
    navMapId,
    setNavMapId,
    setBackImageToggle,
    boxSection,
    setBoxSection,
    collId,
    setCollId,
    isBackgroundColor,
    setIsBackgroundColor,
    setImgShow,
    theme,
    setTheme,
    sectionPageName,
    setSectionPageName,
    imageIs,
  } = useContext(StepsContext);
  const { setLoaderShow } = useContext(LoaderContext);

  /**
   * get steps parent list
   * @param {status} status
   */
  const getStepsParentList = async ({
    parentId = null,
    isClose = false,
    filter,
  }) => {
    try {
      let paramObj = {
        showAll: true,
      };
      if (
        ((parentId && parentId !== null) ||
          (id && isClose === false && isParent === false)) &&
        isParent === false
      ) {
        paramObj["search"] = { parentId: parentId || id };
        setId(parentId || id);
        if (filter?.length) {
          paramObj["search"] = { ...paramObj.search, title: filter };
        }
      } else {
        paramObj["search"] = { parentId: null };
      }
      const { data } = await getSteps(paramObj);

      if (isCheckValue({ value: parentId })) {
        setChildId(parentId);
      }
      if (data.status === 200) {
        if (
          isParent === false &&
          ((parentId && parentId !== null) || id) &&
          isClose === false
        ) {
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.stepId,
                Id: elem?.stepId,
                name: elem?.title,
                image: "",
                webId: elem?.webId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
                parentId: elem?.parentId,
              };
            }),
          });
          OpenModalCommonFunc(Cases.STEPS, setAllPopupState);
        } else if (parentId && parentId !== null) {
          OpenModalCommonFunc(Cases.STEPS, setAllPopupState);
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.stepId,
                Id: elem?.stepId,
                name: elem?.title,
                image: elem?.image,
                webId: elem?.webId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
                parentId: elem?.parentId,
              };
            }),
          });
        } else {
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data,
          });
        }
        if (isClose && isClose !== false) {
          setIsParent(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * item steps enable disable api call
   * @param {stepId} stepId
   * @param {status} isActive
   */

  const handleChangeSteps = async (stepId, isActive, isChild, parentId) => {
    try {
      let body = {
        stepId,
        isActive: isActive ? false : true,
      };
      if (parentId) {
        body["parentId"] = parentId;
      }
      const { data } = await updateStatus(body);
      if (data.status === 200) {
        if (isChild) {
          getStepsParentList({ parentId: parentId });
        } else {
          ByteMiniWeb_Dashboard();
        }
        TostMessage({ message: data, type: "success" });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * file upload
   * @param {file} file
   */
  const imageUploadImages = async (file) => {
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.STEP);
    // formData.append("file", file);
    setLoaderShow(true);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.STEP,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        setSettingFormData((prev) => {
          if (imageIs === "stepImage1") {
            return {
              ...prev,
              ".step-by-step-section.bg-image": {
                "background-image":
                  data.payload.baseUrl + data.payload.imageUrl,
              },
            };
          } else if (imageIs === "stepImage2") {
            return {
              ...prev,
              ".step-by-step-section-1.bg-image": {
                "background-image":
                  data.payload.baseUrl + data.payload.imageUrl,
              },
            };
          }
        });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * image upload
   * @param {file} file
   */
  const imageUpload = async (file) => {
    setLoaderShow(true);
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.STEP);
    // formData.append("file", file);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.STEP,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        setFormDataChild((prev) => {
          return {
            ...prev,
            image: data.payload.baseUrl + data.payload.imageUrl,
          };
        });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * create and update steps
   */
  const submitForm = async () => {
    if (
      (isParent === false && childId >= -1 && isEdit) ||
      (id >= -1 && isEdit)
    ) {
      setLoaderShow(true);
      try {
        let formData = {};
        if (isParent && isParent !== false) {
          formData = { ...fromData, stepId: id, contentMapId: collId };
        } else {
          formData = {
            ...formDataChild,
            parentId: id,
            navMapId,
            stepId: childId,
            contentMapId: collId,
          };
          if (formDataChild.image?.length) {
            formData["image"] = formDataChild.image
              .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
              .pop();
          }
        }
        const { data } = await putUpdateSteps(formData);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            ByteMiniWeb_Dashboard();
          } else {
            getStepsParentList({ parentId: id });
          }
          emptyData();
          OpenModalCommonFunc(Cases.STEPS_PARENT, setAllPopupState, false);
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    } else {
      try {
        setLoaderShow(true);
        let formData = {};
        if (isParent && isParent !== false) {
          formData = { ...fromData, contentMapId: collId };
        } else {
          formData = {
            ...formDataChild,
            parentId: id,
            navMapId,
            order: apiDataImageParent.data.length + 1,
            contentMapId: collId,
          };
          if (formDataChild.image?.length) {
            formData["image"] = formDataChild.image
              .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
              .pop();
          }
        }
        const { data } = await postSteps(formData);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            ByteMiniWeb_Dashboard();
          } else {
            getStepsParentList({ parentId: id });
          }
          emptyData();
          OpenModalCommonFunc(Cases.STEPS_PARENT, setAllPopupState, false);
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };
  const handleSubmit = async (formValidationCondition) => {
    let validatorFields;
    if (formValidationCondition === "parentForm") {
      validatorFields = parentValidator.current;
    } else if (formValidationCondition === "childForm") {
      validatorFields = childValidator.current;
    }
    validatorFields.showMessages();
    if (validatorFields.allValid()) {
      try {
        // Process form data based on the formType
        if (formValidationCondition === "parentForm") {
          submitForm();
        } else if (formValidationCondition === "childForm") {
          submitForm();
        }
        validatorFields.hideMessages();
      } catch (error) {
        // Handle error for form submission
      }
    } else {
      // Force update to display validation messages
      forceUpdate({});
    }
  };

  /**
   * create and update steps
   */
  const handleSubmitSetting = async (isRestore = false, isClose = true) => {
    if (id >= -1 && isEdit) {
      setLoaderShow(true);
      try {
        let newData;
        if (isRestore) {
          const isConfirm = window.confirm(
            "Are you sure want to restore style ?"
          );
          if (isConfirm) {
            newData = {
              styleRestore: true,
              stepId: id,
            };
          } else {
            setLoaderShow(false);
            return;
          }
        } else {
          if (+theme === ThemeNo.ThemeOne) {
            newData = StepsStyleOneSubFun({
              settingFormData,
              boxSection,
            });
            if (isBackgroundColor) {
              newData[".step-by-step-section"] = {
                ...newData?.[".step-by-step-section"],
                "background-color": settingFormData[".step-by-step-section"][
                  "background-color"
                ]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData[".step-by-step-section"][
                      "background-color"
                      ],
                  })
                  : "",
              };
            }
            if (boxSection) {
              newData[".step-by-step-section.bg-image::before"] = {
                ...newData[".step-by-step-section.bg-image::before"],
                "border-radius": `${settingFormData[".step-by-step-section"][
                  "border-radius"
                ]?.replace("rem", "")}rem`,
              };
            }
          } else if (+theme === ThemeNo.ThemeTwo) {
            newData = StepsStyleTwoSubFun({
              settingFormData,
              boxSection,
            });
            if (isBackgroundColor) {
              newData[".step-by-step-section-1"] = {
                ...newData?.[".step-by-step-section-1"],
                "background-color": settingFormData[".step-by-step-section-1"][
                  "background-color"
                ]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData[".step-by-step-section-1"][
                      "background-color"
                      ],
                  })
                  : "",
              };
            }
            if (boxSection) {
              newData[".step-by-step-section-1.bg-image::before"] = {
                ...newData[".step-by-step-section-1.bg-image::before"],
                "border-radius": `${settingFormData[".step-by-step-section-1"][
                  "border-radius"
                ]?.replace("rem", "")}rem`,
              };
            }
          }

          const keysToRemove = [""];
          function removeKeys(obj, keys) {
            for (const key in obj) {
              if (typeof obj[key] === "object") {
                removeKeys(obj[key], keys);
              } else if (keys.includes(key)) {
                delete obj[key];
              }
            }
          }
          if (newData?.image) {
            delete newData?.image;
          }

          removeKeys(newData, keysToRemove);
          newData = {
            style: newData,
            stepId: id,
          };
        }

        const { data } = await putUpdateSteps(newData);
        if (data.status === 200) {
          getStepsParentList({ isClose: true });
          if (isClose) {
            OpenModalCommonFunc(
              Cases.SETTING_STEPS_PARENT,
              setAllPopupState,
              false
            );
            setBackImageToggle(false);
            emptyData();
          }
          setLoaderShow(false);
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  /**
   * get data steps
   * @param {id} stepId
   */
  const handleEditSteps = async (stepId, isParent) => {
    try {
      setLoaderShow(true);
      const { data } = await getStepsDetails(stepId);
      if (data.status === 200) {
        let payload = data.payload.data;
        if (isParent) {
          setSectionPageName(payload?.title);
          setId(stepId);
          setIsParent(true);
          setFormData({
            title: payload?.title || "",
            subTitle: payload?.subTitle || "",
            theme: payload?.theme || "",
            isTitleShow: payload?.isTitleShow ? payload?.isTitleShow : false,
            navMapId: payload?.navMapId || "",
            webId: localStorage.getItem("webId"),
            style: payload?.style || "",
          });
          OpenModalCommonFunc(Cases.STEPS_PARENT, setAllPopupState);
        } else {
          setChildId(stepId);
          setIsParent(false);
          setFormDataChild({
            title: payload?.title || "",
            subTitle: payload?.subTitle || "",
            isTitleShow: payload?.isTitleShow ? payload?.isTitleShow : false,
            description: payload?.description || "",
            imageAlt: payload?.imageAlt || "",
            image: payload?.image || "",
            parentId: payload?.parentId || "",
            order: payload?.order || 1,
            webId: localStorage.getItem("webId"),
          });
          OpenModalCommonFunc(Cases.STEPS, setAllPopupState);
        }
        setIsEdit(true);
        TostMessage({ message: data, type: "success" });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * get setting data
   * @param {id} stepId
   */
  const handleChangeSettings = async (stepId, isThemeEdit = false) => {
    try {
      setLoaderShow(true);
      setId(stepId);
      setSettingFormData((prev) => {
        return {
          ...prev,
          stepId,
        };
      });
      const { data } = await getStepsDetails(stepId);
      if (data.status === 200) {
        const themeCount = data?.payload?.data?.theme;
        setTheme(themeCount);
        setImgShow(true);
        let payload = data.payload.data;
        setSectionPageName(payload.title);
        if (
          +themeCount === ThemeNo.ThemeOne &&
          isEmptyObject(data?.payload?.data?.style)
        ) {
          setSettingFormData({ ...StepsStyleOneReset });
          setBoxSection(false);
          setIsBackgroundColor(false);
          setBackImageToggle(false);
        } else {
          if (
            payload.style?.[".step-by-step-section"]?.["width"] ||
            payload.style?.[".step-by-step-section"]?.["margin"] ||
            payload.style?.[".step-by-step-section"]?.["border-radius"] ||
            payload.style?.[".step-by-step-section-1"]?.["width"] ||
            payload.style?.[".step-by-step-section-1"]?.["margin"] ||
            payload.style?.[".step-by-step-section-1"]?.["border-radius"]
          ) {
            setBoxSection(true);
          }
          if (
            payload.style?.[".step-by-step-section.bg-image"]?.[
            "background-image"
            ] ||
            payload.style?.[".step-by-step-section-1.bg-image"]?.[
            "background-image"
            ]
          ) {
            setBackImageToggle(true);
          }
          if (
            payload.style?.[".step-by-step-section"]?.["background-color"] ||
            payload.style?.[".step-by-step-section-1"]?.["background-color"]
          ) {
            setIsBackgroundColor(true);
          }
          let getStyle;
          if (+themeCount === ThemeNo.ThemeOne) {
            getStyle = StepsThemeOneFunction(payload);
          } else if (+themeCount === ThemeNo.ThemeTwo) {
            getStyle = StepsThemeTwoFunction(payload);
          } else {
            getStyle = StepsThemeOneFunction(payload);
          }
          setSettingFormData((prev) => {
            return {
              ...prev,
              ...getStyle,
            };
          });
        }
        if (!isThemeEdit) {
          OpenModalCommonFunc(Cases.SETTING_STEPS_PARENT, setAllPopupState);
          TostMessage({ message: data, type: "success" });
        }
        setIsEdit(true);
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * delete steps
   * @param {id} stepId
   */
  const handleDelete = async (stepId, isParent = false) => {
    let conformation = window.confirm(DELETE_CONFIRM);
    try {
      if (conformation) {
        setLoaderShow(true);
        const { data } = await deleteSteps(stepId);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            // getStepsParentList(null, true);
            ByteMiniWeb_Dashboard();
          } else {
            getStepsParentList({ packageId: childId });
          }
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * clear data
   */
  const emptyData = () => {
    setIsBackgroundColor(false);
    setBoxSection(false);
    setIsEdit(false);
    setIsParent(false);
    setChildId("");
    setFormData({
      title: "",
      subTitle: "",
      navMapId: "",
      isTitleShow: true,
      theme: 1,
      webId: localStorage.getItem("webId"),
      style: {
        ".step-by-step-section": {
          padding: "100px 0",
          "background-color": "rgb(255 255 255 / 100)",
        },
        ".step-by-step-section.bg-image": {
          "background-image": "",
        },
        ".step-by-step-section.bg-image::before": {
          "background-color": "",
        },
        ".step-by-step-section .section-title-area": {
          "margin-bottom": "50px",
        },
        ".step-by-step-section .section-title-area .section-subtitle": {
          "font-size": "16px",
          "font-weight": "600",
          color: "rgb(255 73 124 / 100)",
          "background-color": "rgb(255 73 124 / 0.2)",
          padding: "5px 20px",
          "border-radius": "15px",
          "margin-bottom": "15px",
        },
        ".step-by-step-section .section-title-area .section-title": {
          "font-size": "44px",
          "font-weight": "600",
          color: "rgb(0 0 0 / 100)",
        },
        ".step-by-step-section .stepdiv": {
          padding: "10px",
          "text-align": "center",
        },
        ".step-by-step-section .stepdiv .step-count": {
          width: "60px",
          height: "60px",
          color: "rgb(255 255 255 / 100)",
          "font-size": "30px",
          "font-weight": "600",
          padding: "12px 5px",
          "margin-bottom": "30px",
          "background-color": "rgb(255 73 124 / 100)",
          "border-radius": "50%",
        },
        ".step-by-step-section .stepdiv h4": {
          color: "rgb(0 0 0 / 100)",
          "font-weight": "600",
          "font-size": "20px",
          "margin-bottom": "15px",
        },
        ".step-by-step-section .stepdiv p": {
          color: "rgb(127 127 127 / 100)",
          "font-weight": "300",
          "font-size": "14px",
          "line-height": "1.6",
        },
        stepId: "",
      },
    });
    setSkill([{ id: randomStr(2), skill: "", parentageOfSkill: "" }]);
    setGalleryImgId("");
    setFormDataChild({
      title: "",
      subTitle: "",
      description: "",
      imageAlt: "",
      isTitleShow: true,
      order: 1,
      webId: localStorage.getItem("webId"),
      navMapId: "",
    });
    setLoaderShow(false);
    setSettingFormData({
      ".step-by-step-section": {
        padding: "100px 0",
        "background-color": "rgb(255 255 255 / 100)",
      },
      ".step-by-step-section.bg-image": {
        "background-image": "",
      },
      ".step-by-step-section.bg-image::before": {
        "background-color": "",
      },
      ".step-by-step-section .section-title-area": {
        "margin-bottom": "50px",
      },
      ".step-by-step-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: "rgb(255 73 124 / 100)",
        "background-color": "rgb(255 73 124 / 0.2)",
        padding: "5px 20px",
        "border-radius": "15px",
        "margin-bottom": "15px",
      },
      ".step-by-step-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: "rgb(0 0 0 / 100)",
      },
      ".step-by-step-section .stepdiv": {
        padding: "10px",
        "text-align": "center",
      },
      ".step-by-step-section .stepdiv .step-count": {
        width: "60px",
        height: "60px",
        color: "rgb(255 255 255 / 100)",
        "font-size": "30px",
        "font-weight": "600",
        padding: "12px 5px",
        "margin-bottom": "30px",
        "background-color": "rgb(255 73 124 / 100)",
        "border-radius": "50%",
      },
      ".step-by-step-section .stepdiv h4": {
        color: "rgb(0 0 0 / 100)",
        "font-weight": "600",
        "font-size": "20px",
        "margin-bottom": "15px",
      },
      ".step-by-step-section .stepdiv p": {
        color: "rgb(127 127 127 / 100)",
        "font-weight": "300",
        "font-size": "14px",
        "line-height": "1.6",
      },
      stepId: "",
    });
    // parentValidator.hideMessages();
  };

  const handleAlignAndCloneSection = ({ isClone = false }) => {
    if (isClone) {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          cloneModal: true,
        };
      });
      setCloneFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          pageConfigDetailsLabel: pageConfigDetails[0]?.label,
          contentDetailName: contentDetail.name,
        };
      });
    } else {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          alignModal: true,
        };
      });
      setAlignFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          label: pageConfigDetails[0]?.label,
        };
      });
    }
  };

  useEffect(() => {
    if (stepsDetail?.theme) {
      setTheme(stepsDetail.theme);
    }
  }, [stepsDetail?.theme]);
  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody
            className="support-ticket-font box-border-div"
            style={{ padding: "20px" }}
          >
            <Row>
              <CardBuilderHeaderSection
                addBtnTitle={pageConfigDetails[0]?.label}
                name={pageConfigDetails[0]?.label}
                isAdd={!stepsDetail && true}
                mainEditSection={true}
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
                openModal={() => {
                  OpenModalCommonFunc(Cases.STEPS_PARENT, setAllPopupState);
                  setSectionPageName(modalsName.STEPS_PARENT);
                  emptyData();
                  setIsParent(true);
                  setCollId(contentMapId);
                }}
                isCloneSection={true}
                isAlignSection={true}
                handleAlignAndCloneSection={handleAlignAndCloneSection}
              />
              {stepsDetail && (
                <Col xl="12 xl-50 box-col-6" md="6">
                  <Card className="ecommerce-widget mb-0">
                    <CardBody
                      className="support-ticket-font"
                      style={{ padding: "20px" }}
                    >
                      <div className="col-12">
                        <CardBuilderHeaderSection
                          name={stepsDetail?.title}
                          checked={stepsDetail?.isActive}
                          switchToggle={true}
                          id={stepsDetail?.stepId}
                          handleChange={handleChangeSteps}
                        />
                        <OpenPopupBtn
                          openPopup={() => {
                            getStepsParentList({
                              parentId: stepsDetail.stepId,
                            });
                            setSectionPageName(stepsDetail?.title);
                            setNavMapId(stepsDetail?.navMapId);
                            setFilter("");
                            setCollId(contentMapId);
                          }}
                          name={`Add or View ${stepsDetail?.title}`}
                        />
                      </div>
                      <div className="d-flex justify-content-end ">
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            handleEditSteps(stepsDetail.stepId, true);
                            setCollId(contentMapId);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => handleDelete(stepsDetail.stepId, true)}
                        >
                          <Trash />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            handleChangeSettings(stepsDetail.stepId);
                          }}
                        >
                          <Settings />
                        </IconButton>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              )}
              <DeleteSection
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
              />
            </Row>
          </CardBody>
        </Card>
      </Col>
      <CommonPopup
        open={allPopupState.stepsChildPopup}
        close={() => {
          OpenModalCommonFunc(Cases.STEPS, setAllPopupState, false);
          setIsParent(false);
          getStepsParentList({ isClose: true });
        }}
        apiCall={getStepsParentList}
        modalName={sectionPageName ? sectionPageName : modalsName.STEPS}
        modalCase={Cases.STEPS}
        handleSubmit={handleSubmit}
        validationForm={"childForm"}
        emptyData={emptyData}
        inputData={fromData}
        edit={false}
        oldTitle={titleUpdateKey.isGallery}
        label={titleUpdateKey.Certificates}
        getData={getData}
        content={
          <StepsPopup
            handleChangeStatus={handleChangeSteps}
            handleEdit={handleEditSteps}
            imageUpload={imageUpload}
            emptyData={emptyData}
            simpleValidator={childValidator}
            webMasterDetail={webMasterDetail}
            handleDelete={handleDelete}
            getStepsParentList={getStepsParentList}
          />
        }
      />

      {/* item faqs popup */}
      <CommonPopup
        open={allPopupState.stepsPopup}
        close={() => {
          OpenModalCommonFunc(Cases.STEPS_PARENT, setAllPopupState, false);
          setIsParent(false);
        }}
        modalName={sectionPageName ? sectionPageName : modalsName.STEPS_PARENT}
        modalCase={Cases.STEPS_PARENT}
        handleSubmit={handleSubmit}
        validationForm={"parentForm"}
        emptyData={emptyData}
        inputData={formDataChild}
        edit={false}
        content={<StepsParentPopup simpleValidator={parentValidator} />}
      />

      {/* setting Service Counter parent popup */}
      <CommonPopup
        open={allPopupState.stepsParenPopup}
        close={() =>
          OpenModalCommonFunc(
            Cases.SETTING_STEPS_PARENT,
            setAllPopupState,
            false
          )
        }
        modalName={
          sectionPageName ? sectionPageName : modalsName.SETTING_STEPS_PARENT
        }
        modalCase={Cases.SETTING_STEPS_PARENT}
        handleSubmit={handleSubmitSetting}
        emptyData={emptyData}
        inputData={formDataChild}
        edit={false}
        content={
          <SettingStepsParentPopup
            imageUpload={imageUploadImages}
            handleSubmitSetting={handleSubmitSetting}
            handleChangeSettings={handleChangeSettings}
          />
        }
      />
    </>
  );
};

export default Steps;
